import Pagination, { PaginationInitializer } from '../valueobjects/Pagination';
import Area, { AreaInitializer } from './Area';
import BusinessHour, { BusinessHourInit } from './BusinessHour';
import MerchantFeature, { MerchantFeatureInit } from './MerchantFeature';
import MerchantImageGallery, {
  MerchantImageGalleryInit,
} from './MerchantImageGallery';
import MerchantRating, { MerchantRatingInit } from './MerchantRating';
import MerchantSetting, { MerchantSettingInit } from './MerchantSetting';

export interface MerchantInit {
  publicId: string;
  address: string;
  area: AreaInitializer | null;
  businessHours: BusinessHourInit[];
  coverImage: {
    fileName: string;
    url: string;
  };
  description: string;
  displayName: string;
  favoriteCount: number;
  feature?: MerchantFeatureInit;
  merchantCategoryId: number;
  metaSetting: {
    title: string;
    isNoIndex: boolean;
    keyword: string;
    description: string;
  };
  phoneNumber: string;
  rating: MerchantRatingInit;
  setting: MerchantSettingInit;
  thumbnailImage: {
    original: { url: string };
    w120: { url: string };
    w300: { url: string };
    w1280: { url: string };
  };
  gallery: MerchantImageGalleryInit[];
  timeZone: string;
}

export default class Merchant {
  public readonly publicId: string;
  public readonly address: string;
  // Deprecated
  public readonly area: Area | null;
  public readonly businessHours: BusinessHour[];
  public readonly coverImage: {
    fileName: string;
    url: string;
  };
  public readonly description: string;
  public readonly displayName: string;
  public readonly favoriteCount: number;
  public readonly feature: MerchantFeature;
  public readonly merchantCategoryId: number;
  public readonly metaSetting: {
    title: string;
    isNoIndex: boolean;
    keyword: string;
    description: string;
  };
  public readonly phoneNumber: string;
  public readonly rating: MerchantRating;
  public readonly setting: MerchantSetting;
  public readonly thumbnailImage: {
    original: { url: string };
    w120: { url: string };
    w300: { url: string };
    w1280: { url: string };
  };

  public readonly gallery: MerchantImageGallery[];
  public readonly timeZone: string;

  constructor(init: MerchantInit) {
    this.publicId = init.publicId;
    this.address = init.address;
    this.area = init.area ? new Area(init.area) : null;
    this.businessHours = init.businessHours.map(i => new BusinessHour(i));
    this.coverImage = init.coverImage;
    this.description = init.description;
    this.displayName = init.displayName;
    this.favoriteCount = init.favoriteCount;
    this.feature = init.feature ? init.feature : new MerchantFeature();
    this.merchantCategoryId = init.merchantCategoryId;
    this.metaSetting = init.metaSetting;
    this.phoneNumber = init.phoneNumber;
    this.rating = new MerchantRating(init.rating);
    this.setting = new MerchantSetting(init.setting);
    this.thumbnailImage = init.thumbnailImage;
    this.gallery = init.gallery.map(p => new MerchantImageGallery(p));
    this.timeZone = init.timeZone;
  }
}

export class MerchantList {
  public readonly merchants: Merchant[];
  public readonly pagination: Pagination;

  constructor(inits: MerchantInit[], pagination: PaginationInitializer) {
    this.pagination = new Pagination(pagination);

    this.merchants = [];
    inits.map(init => {
      this.merchants.push(new Merchant(init));
    });
  }
}
